import { useRecordContext } from "ra-core";
import { Badge } from "@/components/ui/badge";
import type { Company, Contact } from "../types";

/**
 * Small inline icon for list views indicating BC sync status.
 */
export const BCSyncIcon = () => (
  <span
    title="Synced from Business Central"
    className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full bg-blue-100 text-blue-500 shrink-0"
    style={{ fontSize: "9px", lineHeight: 1 }}
  >
    ⟳
  </span>
);

/**
 * Shows a "Synced from Business Central" badge when the record is BC-managed.
 * Used in Company and Contact edit forms to indicate read-only fields.
 */
export const BCSyncBadge = () => {
  const record = useRecordContext<Company | Contact>();
  if (!record?.bc_synced) return null;

  return (
    <Badge
      variant="outline"
      className="text-xs text-muted-foreground border-blue-300 text-blue-600 bg-blue-50 gap-1"
    >
      <span>⟳</span>
      Synced from Business Central
    </Badge>
  );
};

/**
 * Returns true when the current record is synced from BC.
 * Use this to conditionally disable BC-managed fields.
 */
export const useBCSynced = (): boolean => {
  const record = useRecordContext<Company | Contact>();
  return !!record?.bc_synced;
};
